// extracted by mini-css-extract-plugin
export default {"cont__footer":"footerStyle_cont__footer__fvR4I","cont__footer_inside":"footerStyle_cont__footer_inside__u0E+5","cont__footer_under":"footerStyle_cont__footer_under__KWc68"};